export function decodeItem(itemEncoded) {
  const id = (itemEncoded >> 8) & 0b1111111;
  const quantity = (itemEncoded >> 5) & 0b111;
  const duration = itemEncoded & 0b11111;

  return {
    id: id,
    quantity: quantity,
    duration: duration,
  };
}

export function getItemDescription(itemList, demo) {
  const decodedItem = decodeItem(demo);

  if (!decodedItem) {
    return "";
  }

  const foundItem = itemList.find((item) => item.Id === decodedItem.id);

  const durationText =
    decodedItem.duration === 0
      ? "Vĩnh viễn"
      : `Thời hạn: ${decodedItem.duration} ngày`;

  if (foundItem) {
    return `${foundItem.Name} - Số lượng: ${decodedItem.quantity} - ${durationText}`;
  }

  return "";
}
